import type { ReactNode } from 'react';
import { CalendarCheck2, LayoutDashboard, UserRound } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface PanelLayoutProps {
  children: ReactNode;
}

const navigation = [
  { label: 'Overview', href: '/panel', icon: LayoutDashboard },
  { label: 'Assigned interviews', href: '/panel/interviews', icon: CalendarCheck2 },
  { label: 'My career', href: '/dashboard', icon: UserRound },
];

export function PanelLayout({ children }: PanelLayoutProps) {
  const location = useLocation();

  const isActive = (href: string) =>
    href === '/panel' ? location.pathname === href : location.pathname.startsWith(href);

  return (
    <div className="min-h-[calc(100vh-7rem)] bg-surface-muted">
      <div className="mx-auto max-w-7xl px-4 py-5 sm:px-6 lg:grid lg:grid-cols-[220px_minmax(0,1fr)] lg:gap-8 lg:py-7">
        <aside className="mb-5 lg:mb-0">
          <div className="lg:sticky lg:top-28">
            <div className="mb-4 hidden lg:block">
              <div className="text-sm font-semibold text-text">Panel workspace</div>
              <div className="mt-1 text-xs text-text-muted">NIEDO interview evaluations</div>
            </div>
            <nav className="flex gap-2 overflow-x-auto border-b border-border pb-3 lg:flex-col lg:overflow-visible lg:border-b-0 lg:pb-0" aria-label="Panel workspace">
              {navigation.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.href);
                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={`flex min-h-11 shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                      active
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-text-muted hover:bg-surface hover:text-text'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
        </aside>
        <main className="min-w-0">{children}</main>
      </div>
    </div>
  );
}
